import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { NoResults } from '@/components'
import { useMobile } from '@/hooks'
import { TimelineTicket } from '@/types/Homes'
import { MemberDetail } from '@/types/User'
import { MobileTicketCard } from '@/views/Ticket/Tickets/MobileTicketCard'

import { MemberTicketListColumns } from './MemberTickets.data'

export const MemberTickets = ({ member }: { member: MemberDetail }) => {
  const { isTablet } = useMobile()

  const tickets = member.tickets || []

  const columns = useMemo(() => {
    return MemberTicketListColumns
  }, [])

  return (
    <div className="flex w-full flex-col py-4">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className=" text-header-lg leading-120">Tickets</h2>
      </div>
      {isTablet ? (
        <>
          {(tickets.length > 0 &&
            tickets.map((ticket, index) => (
              <MobileTicketCard includeMarket={false} key={index} ticket={ticket as TimelineTicket} />
            ))) || <NoResults />}
        </>
      ) : (
        <Table columns={columns as any} data={tickets} />
      )}
    </div>
  )
}
